import { Box, Typography } from '@mui/material';

export default function PsiTrainingPage() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 1.5, fontWeight: 700 }}>
        Formación
      </Typography>
      <Typography variant="h6" color="text.secondary">
        Próximamente
      </Typography>
    </Box>
  );
}
